export default __webpack_public_path__ + "static/media/nr.f97b92dc.svg";